import TextInputOld from './TextInputOld';
import InputWrapper from '../inputField/InputWrapper';
import type { InputState, Link } from '../inputField/types';

export { InputWrapper, Link, InputState };
export default TextInputOld;
